import { render, staticRenderFns } from "./xeSelfRateTocSetting.vue?vue&type=template&id=86eb00c8"
import script from "./xeSelfRateTocSetting.vue?vue&type=script&lang=js"
export * from "./xeSelfRateTocSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports